const translateWallet = {
  es: {
    STPModal: {
      stpButton: 'Depósito',
      title: "Transferencia STP",
      description:
        "Entra a la aplicación de cualquier banco e ingresa los siguientes datos",
      backButton: "Regresar",
      coppied: "*El número se ha copiado",
      destinyTitle: "Banco de destino",
      destinyText: "Sistema de Transferencia y Pagos (STP)",
      clabeTitle: "CLABE interbancaria",
      holderTitle: "Titular de la cuenta",
      warning: "*La transferencia puede tardar unos minutos en reflejarse",
    },
  },
  en: {
    STPModal: {
      stpButton: 'Deposit',
      title: "STP Transfer",
      description:
        "Enter the application of any bank and enter the following information",
      backButton: "Back",
      coppied: "*Number on clipboard",
      destinyTitle: "Destination bank",
      destinyText: "Sistema de Transferencia y Pagos (STP)",
      clabeTitle: "CLABE number",
      holderTitle: "Account holder",
      warning: "*It may take a few minutes for the transaction to be reflected",
    },
  },
};

export default translateWallet;
